module.exports = __webpack_public_path__ + "img/top_bg.efed9d86.png";